import React, { useEffect, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import api from '../../../api/axiosInstance';
import { registerPushSubscription } from '../../../utils/pushNotifications';

export const EnableNotificationsButton: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [isSupported, setIsSupported] = useState(true);
  const [isSubscribed, setIsSubscribed] = useState<boolean | null>(null);

  useEffect(() => {
    const checkSubscription = async () => {
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        setIsSupported(false);
        return;
      }

      try {
        const registration = await navigator.serviceWorker.getRegistration();
        if (!registration) {
          setIsSubscribed(false);
          return;
        }

        const sub = await registration.pushManager.getSubscription();
        setIsSubscribed(!!sub);
      } catch (e) {
        setIsSubscribed(false);
      }
    };

    checkSubscription();
  }, []);

  const unsubscribeOnThisDevice = async () => {
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) {
      setIsSubscribed(false);
      return;
    }

    const sub = await registration.pushManager.getSubscription();
    if (!sub) {
      setIsSubscribed(false);
      return;
    }

    const json = sub.toJSON() as PushSubscriptionJSON & { endpoint?: string };

    if (!json.endpoint) {
      return;
    }

    await api.post('/notifications/unsubscribe', {
      endpoint: json.endpoint,
    });

    await sub.unsubscribe();
    setIsSubscribed(false);
  };

  const handleClick = async () => {
    if (!isSupported) return;

    setLoading(true);
    try {
      if (isSubscribed) {
        await unsubscribeOnThisDevice();
      } else {
        await registerPushSubscription();
        setIsSubscribed(true);
      }
    } catch (e) {
      alert('Не удалось изменить настройки уведомлений. Попробуйте позже.');
    } finally {
      setLoading(false);
    }
  };

  if (!isSupported) {
    return null;
  }

  const text = loading
    ? 'Обрабатываем...'
    : isSubscribed
      ? 'Отключить уведомления'
      : 'Включить уведомления о расходах';

  const variant = isSubscribed ? 'text' : 'outlined';

  return (
    <Button
      variant={variant}
      color="primary"
      disabled={loading || isSubscribed === null}
      onClick={handleClick}
      startIcon={loading ? <CircularProgress size={18} /> : undefined}
    >
      {text}
    </Button>
  );
};

export default EnableNotificationsButton;
